/*
 * custom-fm-features.js
 * Behaviour for the size chart modal (category tabs + cm/inch toggle).
 *
 * The modal itself is a Dawn <modal-dialog>, so opening, closing, focus
 * trapping and Escape handling are already covered by global.js. This file
 * only manages which table is visible.
 */
(function () {
  'use strict';

  function panelsIn(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-sc-panel]'));
  }

  function currentState(root) {
    var activeTab = root.querySelector('.size-chart__tab.is-active');
    var activeUnit = root.querySelector('.size-chart__unit.is-active');
    return {
      tab: activeTab ? activeTab.dataset.scTab : '1',
      unit: activeUnit ? activeUnit.dataset.scUnit : 'cm',
    };
  }

  function sync(root) {
    var state = currentState(root);
    var panels = panelsIn(root);
    var matched = false;

    panels.forEach(function (panel) {
      var isMatch =
        panel.dataset.scPanelTab === state.tab && panel.dataset.scPanelUnit === state.unit;
      panel.hidden = !isMatch;
      if (isMatch) matched = true;
    });

    // If the shop only filled in one unit for this tab, show whatever exists
    // rather than leaving the modal blank.
    if (!matched && panels.length) {
      var fallback =
        panels.filter(function (p) {
          return p.dataset.scPanelTab === state.tab;
        })[0] || panels[0];
      fallback.hidden = false;
    }
  }

  function bind(root) {
    if (root.dataset.scReady === 'true') return;
    root.dataset.scReady = 'true';

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('.size-chart__tab');
      var unit = event.target.closest('.size-chart__unit');

      if (tab) {
        root.querySelectorAll('.size-chart__tab').forEach(function (el) {
          var active = el === tab;
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        sync(root);
        return;
      }

      if (unit) {
        root.querySelectorAll('.size-chart__unit').forEach(function (el) {
          el.classList.toggle('is-active', el === unit);
        });
        sync(root);
      }
    });

    sync(root);
  }

  function init() {
    document.querySelectorAll('.size-chart').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections without a full page load
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
